// extracted by mini-css-extract-plugin
export default {"container":"HeaderDisclamer_container__r0Ljl","content":"HeaderDisclamer_content__VgpvP"};